import React from 'react';
import { Query } from 'react-apollo';

import ACCOUNT_INFO_QUERY from '../gql/lookupRegistrationByUser.query';
import REGISTRATION_QUERY from '../gql/schoolOrDistrictRegistration.query';
import PaymentContainerContents from './PaymentContainerContents';

/* if registrationId in the state is detected, we know to fetch the registraiton Info with registrationId */
const RegistrationFetchingQuery = ({
  id,
  registrationVariables,
  didWriteRegistrationIdToRedux,
  paymentAssigneeName,
  isPaymentAssigneePresent,
  isAgreementAssigneePresent,
  event,
  token,
  showModal,
  closeModal,
  onLoadRegistrationId,
  handleState,
  handleContinue,
  openAccordion,
  whichAccordionIsOpen,
}) => {
  return (
    <Query
      query={id ? REGISTRATION_QUERY : ACCOUNT_INFO_QUERY}
      variables={registrationVariables}
      pollInterval={3000}
    >
      {({ loading, error, data }) => (
        <PaymentContainerContents
          didWriteRegistrationIdToRedux={didWriteRegistrationIdToRedux}
          paymentAssigneeName={paymentAssigneeName}
          isPaymentAssigneePresent={isPaymentAssigneePresent}
          isAgreementAssigneePresent={isAgreementAssigneePresent}
          event={event}
          token={token}
          showModal={showModal}
          closeModal={closeModal}
          onLoadRegistrationId={onLoadRegistrationId}
          handleState={handleState}
          handleContinue={handleContinue}
          openAccordion={openAccordion}
          whichAccordionIsOpen={whichAccordionIsOpen}
          loading={loading}
          error={error}
          data={data}
        />
      )}
    </Query>
  );
};

export default RegistrationFetchingQuery;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/containers/RegistrationFetchingQuery.jsx